require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-how-to-get-a-python-ide-without-the-weight.json") })
        }
      }, "path---blog-how-to-get-a-python-ide-without-the-weight");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-how-to-get-a-python-ide-without-the-weight!./.cache/json/blog-how-to-get-a-python-ide-without-the-weight.json
// module id = 873
// module chunks = 231608221292675